export default function React_Certificate() {
  return (
    <div>
      <h1>React_Certificate Component</h1>
      <p>This is the React_Certificate tutorial page.</p>
    </div>
  );
}
